
// @ts-nocheck
import locale_es_46js_973ce7e5 from "#nuxt-i18n/973ce7e5";
import locale_en_46js_999d207a from "#nuxt-i18n/999d207a";

export const localeCodes =  [
  "es",
  "en"
]

export const localeLoaders = {
  es: [
    {
      key: "locale_es_46js_973ce7e5",
      load: () => Promise.resolve(locale_es_46js_973ce7e5),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46js_999d207a",
      load: () => Promise.resolve(locale_en_46js_999d207a),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    jit: true,
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "es",
      iso: "es-ES",
      files: [
        "/var/www/web/i18n/locales/es.js"
      ]
    },
    {
      code: "en",
      iso: "en-US",
      files: [
        "/var/www/web/i18n/locales/en.js"
      ]
    }
  ],
  defaultLocale: "es",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix",
  lazy: false,
  langDir: "locales/",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "config",
  pages: {
    "empresa/index": {
      es: "/empresa",
      en: "/company"
    },
    "productos/index": {
      es: "/productos",
      en: "/products"
    },
    "productos/contempo/index": {
      es: "/productos/contempo",
      en: "/products/contempo"
    },
    "productos/nature-premium/index": {
      es: "/productos/nature-premium",
      en: "/products/nature-premium"
    },
    "productos/style/index": {
      es: "/productos/style",
      en: "/products/style"
    },
    "productos/puertas-interior/index": {
      es: "/productos/puertas-interior",
      en: "/products/interior-doors"
    },
    "productos/puertas-entrada/index": {
      es: "/productos/puertas-entrada",
      en: "/products/front-doors"
    },
    "productos/puertas-tecnicas/index": {
      es: "/productos/puertas-tecnicas",
      en: "/products/technical-doors"
    },
    "productos/molduras/index": {
      es: "/productos/molduras",
      en: "/products/mouldings"
    },
    "productos/accesorios/index": {
      es: "/productos/accesorios",
      en: "/products/accessories"
    },
    "proyectos/index": {
      es: "/proyectos",
      en: "/projects"
    },
    "proyectos/[alias]": {
      es: "/proyectos/[alias]",
      en: "/projects/[alias]"
    },
    "contacto/index": {
      es: "/contacto",
      en: "/contact"
    },
    "contacto/te-podemos-ayudar/index": {
      es: "/contacto/te-podemos-ayudar",
      en: "/contact/can-we-help"
    },
    "contacto/trabaja-con-nosotros/index": {
      es: "/contacto/trabaja-con-nosotros",
      en: "/contact/work-with-us"
    },
    "descargas/index": {
      es: "/descargas",
      en: "/downloads"
    },
    "aviso-legal/index": {
      es: "/aviso-legal",
      en: "/legal-notice"
    },
    "politica-de-cookies/index": {
      es: "/politica-de-cookies",
      en: "/cookie-policy"
    },
    "politica-de-datos/index": {
      es: "/politica-de-datos",
      en: "/data-policy"
    },
    "politica-de-datos/candidatos/index": {
      es: "/politica-de-datos/candidatos",
      en: "/data-policy/candidates"
    },
    "politica-de-datos/contactos/index": {
      es: "/politica-de-datos/contactos",
      en: "/data-policy/contacts"
    },
    "politica-de-datos/empleados/index": {
      es: "/politica-de-datos/empleados",
      en: "/data-policy/employees"
    },
    "politica-de-datos/libro-de-visitas/index": {
      es: "/politica-de-datos/libro-de-visitas",
      en: "/data-policy/visitor-book"
    },
    "politica-de-datos/videovigilancia/index": {
      es: "/politica-de-datos/videovigilancia",
      en: "/data-policy/video-surveillance"
    },
    "politica-de-datos/negocial/index": {
      es: "/politica-de-datos/negocial",
      en: "/data-policy/business"
    },
    "area-profesional/index": {
      es: "/area-profesional",
      en: "/professional-area"
    }
  },
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "es",
    iso: "es-ES",
    files: [
      {
        path: "/var/www/web/i18n/locales/es.js",
        cache: undefined
      }
    ]
  },
  {
    code: "en",
    iso: "en-US",
    files: [
      {
        path: "/var/www/web/i18n/locales/en.js",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/